class GiftCardProducts {

  constructor() {
  }

  init() {
    let _this = this;
    this.bindEvents();
  }

  bindEvents() {
    let _this = this;

    if (document.querySelector('body.gift-card-product .product-form__submit')) {
      document.querySelector('.product-form__submit').addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        _this.addGiftCardToCart(e);
      }) ;
    }

  }

  addGiftCardToCart(event) {
    let _this = this;
    let submitButton = event.target;
    let variantId = submitButton.closest('form').querySelector('input[name="id"]').value;
    let quantity = submitButton.closest('form').querySelector('input[name="quantity"]').value;

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

    let items = [];

    for(let i=0; i < quantity; i++) {
      items.push({
        'id': variantId,
        'quantity': 1,
        properties: {
          _id: Date.now() + '-' + i
        }
      })
    }

    let formData = {
      'items': items,
      'sections': sectionsToBundle,
      'sections_url': window.location.pathname
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => response.json())
      .then(async (parsedState) => {
        if (parsedState.status) {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: variantId,
            errors: parsedState.errors || parsedState.description,
            message: parsedState.message
          });
          this.handleErrorMessage(parsedState.description);
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
            detail: {
              errorMessage: parsedState.description
            }
          }));

          const submitButtonText = submitButton.querySelector('.btn-text>span');
          if (!submitButtonText || !submitButtonText.hasAttribute('data-sold-out')) return;
          submitButtonText.innerText = submitButtonText.getAttribute('data-sold-out');
          submitButton.setAttribute('aria-disabled', 'true');
          this.error = true;
          return;
        }

        if (Shopify.designMode) {
          if (document.body.classList.contains('template-cart') || theme.settings.cartType === 'page') {
            window.location.href = theme.routes.cart_url;
            return;
          }
        }

        const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET')})).json();
        cartJson['sections'] = parsedState['sections'];

        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId, cart: cartJson });
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: parsedState
          }
        }));

        let cartDrawer = document.querySelector('cart-drawer');
        cartDrawer?.show(submitButton);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        submitButton.removeAttribute('aria-busy');

        if (!this.error) {
          submitButton.removeAttribute('aria-disabled');
        }
      });

  }

}


let giftCardProducts = new GiftCardProducts();
giftCardProducts.init();